import img2 from "./data-assets/tyrion.png";
import img3 from "./data-assets/counter.png";
import img1 from "./data-assets/stableborrow.png";

export const dataObjects = [
  {
    id: 1,
    img: img1,
    name: "STABLE BORROW",
    description: `Stable Borrow (STB), a Web3 Platform where users can Borrow $STC, Earn and Exchange Tokens at-a-go using our Simple and Swift UI with Unique Protocols embedded in our Smart Contracts!.`,
    tools: ["ReactJS", "TailwinCSS", "NPM"],
    github: "https://github.com/STB-Stable-Borrow/stable-borrow-mvp",
    host: "https://www.stableborrow.com",
  },
  {
    id: 2,
    img: img2,
    name: "TYRION",
    description:
      "A web3 e-commerce website to shop for products & swap your gift cards & digital assets for fiat securely in lesser time.",
    tools: ["React", "TailwindCSS", "Context API"],
    github: "https://github.com/TYRIONSTORE/tyrion",
    host: "https://tyrion-two.vercel.app/",
  },
  // {
  //   id: 3,
  //   img: img3,
  //   name: "Counter App",
  //   description:
  //     "This simple App increases the value of the input by 1 when the plus sign is clicked and decreases the value by 1 when the minus sign is clicked. You can also enter any number digit(s) you like as long as it is in the range of positive integers.",
  //   tools: ["React", "TailwindCSS", "NPM"],
  //   github: "https://github.com/qozeemope/counter-app",
  //   host: "https://counter-app1.vercel.app/",
  // },
  // {
  //   id: 4,
  //   img: "",
  //   name: "New Project 2",
  //   description: "qwertyuiopasdfghj",
  //   tools: ["", "", ""],
  //   github: "",
  //   host: "",
  // },
];
